import * as e from "react";
import { forwardRef as i } from "react";
const h = i(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        height: 8.77778,
        rx: 1.94444,
        stroke: "#000",
        width: 8.77778,
        x: 1,
        y: 1
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        height: 8.77778,
        rx: 1.94444,
        stroke: "#000",
        width: 8.77778,
        x: 13.2222,
        y: 1
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        height: 8.77778,
        rx: 1.94444,
        stroke: "#000",
        width: 8.77778,
        x: 13.2222,
        y: 13.2222
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        height: 8.77778,
        rx: 1.94444,
        stroke: "#000",
        width: 8.77778,
        x: 1,
        y: 13.2222
      }
    )
  );
});
export {
  h as BetBuilderBadgeAll
};
